import React from 'react';
import {type ActionMenuListProps} from '@netx/core-components/ActionMenuList';
import useMediaQuery from '@netx/core-components/hooks/useMediaQuery';
import {useTheme} from '@netx/core-components/Theme';
import type {ReactAction} from '@netx/core/bootstrap';
import {ActionMenu, type ActionMenuProps} from './ActionMenu';
import {type ActionMenuHeaderProps} from './ActionMenuHeader';
import {ActionMenuMobile, type ActionMenuMobileProps} from './ActionMenuMobile';

export interface ActionMenuContainerProps
	extends Pick<
			ActionMenuHeaderProps,
			'title' | 'secondaryTitle' | 'icon' | 'severity' | 'avatar'
		>,
		Pick<ActionMenuProps, 'ActionMenuHeader'> {
	actions: Array<ReactAction[] | ReactAction>;
	id?: string;
	open: boolean;
	onAction: ActionMenuListProps['onAction'];
	onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
	slotProps?: {
		popoverProps?: Partial<Omit<ActionMenuProps, 'open' | 'title' | 'onClose'>>;
		mobileMenu?: Partial<
			Omit<ActionMenuMobileProps, 'open' | 'title' | 'onClose'>
		>;
	};
}

export const ActionMenuContainer = ({
	slotProps,
	onAction,
	onClose,
	...props
}: ActionMenuContainerProps) => {
	const theme = useTheme();
	const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const handleContextMenu = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
	};

	const handleClose = (
		event: {},
		reason: 'backdropClick' | 'escapeKeyDown' = 'backdropClick',
	) => {
		onClose?.(event, reason);
	};

	const handleAction = (event: any, action: ReactAction) => {
		onAction(event, action);
		handleClose({}, 'escapeKeyDown');
	};

	return smallScreen ? (
		<ActionMenuMobile
			{...props}
			{...slotProps?.mobileMenu}
			onAction={handleAction}
			onClose={handleClose}
			onOpen={() => {}}
			onContextMenuCapture={handleContextMenu}
		/>
	) : (
		<ActionMenu
			{...props}
			{...slotProps?.popoverProps}
			onAction={handleAction}
			onClose={handleClose}
			onContextMenuCapture={handleContextMenu}
		/>
	);
};
